<template>
    <nav class="navbar navbar-expand-lg fixed-top" id="navbar">
        <div class="container-fluid">
            <img src="../assets/image/logo.png" class="navbar-brand" alt="Login" width="90" />
            <button
                class="navbar-toggler"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#navbarSupportedContent"
                aria-controls="navbarSupportedContent"
                aria-expanded="false"
                aria-label="Toggle navigation"
            >
                <span class="navbar-toggler-icon"></span>
            </button>
            <div class="collapse navbar-collapse" id="navbarSupportedContent">
                <ul class="navbar-nav me-auto mb-2 mb-lg-0">
                    <li class="nav-item" v-for="(route, index) in routedata" :key="index">
                        <router-link :to="route.name" class="nav-linker">{{ route.label }}</router-link>
                    </li>

                    <!-- <li class="nav-item">
            <router-link to="/dashboard" class="nav-linker">Dashboard</router-link>
          </li>
          <li class="nav-item">
            <router-link to="/module-assigner" class="nav-linker">Module Assigner</router-link>
          </li>
          <li class="nav-item">
            <router-link to="/module-center" class="nav-linker">Module Center</router-link>
          </li>
          <li class="nav-item">
            <router-link to="/employee" class="nav-linker">Employee</router-link>
          </li> -->
                    <!-- <li class="nav-item">
            <router-link to="/mailer" class="nav-linker">Mailer</router-link>
          </li> -->
                </ul>
                <div class="d-flex mx-3 gap-2 align-items-center">
                    <img  v-if="$store.state.Auth.user.imageUrl" :src="$store.state.Auth.user.imageUrl" class="profile-img"/>
                    <img  v-else :src="`https://avatars.dicebear.com/api/initials/${$store.state.Auth.user.name}.svg?scale=101&fontSize=36`" class="profile-img"/>
                    <!-- <div> -->
                    <p class="employee-title m-0">{{ $store.state.Auth.user.name }}</p>
                    <!-- <p class="employee-subtitle">{{ structureDesignation(employee.designation) }} - {{ employee.team.name }}</p> -->
                    <!-- </div> -->
                </div>
                <div class="d-flex">
                    <Button label="Logout" @onClick="logout()" class="qb-btn qb-btn-outline-md" />
                </div>
            </div>
        </div>
    </nav>
</template>

<script>
import { deleteToken } from '@/utils/storage';
import Button from '../components/ButtonComponent.vue';
export default {
    name: 'NavbarComponent',
    components: {
        Button,
    },
    props: {
        routedata: {
            type: [],
        },
    },
    methods: {
        logout() {
            deleteToken();
            this.$store.commit('Auth/setUser', null);
            location.reload();
            this.$router.push({ name: 'LoginPage' });
        },
    },
};
</script>

<style lang="scss" scoped>
@import '../assets/scss/color.scss';
@import '../assets/scss/font.scss';
#navbar {
    background-color: #28364d;
    border-bottom: 1px solid $light-200;
}
.nav-item .active {
    border: none;
    color: white;
    font-weight: $font-weight-bold;
    font-size: $font-size-lg;
}
.nav-item {
    margin-left: 25px;
}
.nav-linker {
    color: #a5b5cf;
    font-size: $font-size-md;
    font-weight: $font-weight-normal-2;
    text-decoration: none;
}

.profile-img {
    width: 35px;
    height: 35px;
    border-radius: 50%;
}

.employee-title {
    font-size: $font-size-md;
    font-weight: $font-weight-normal-2;
    margin-bottom: 0px;
    color: $white;
}
</style>
